import { PriceDetails } from '../../../pages/pricing/pricing.Model'

export const validatePriceExpression = (
  price: PriceDetails,
  callback: (isValid: boolean) => void
) => {
  if (
    !price.redondeo ||
    !price.precioUnitario ||
    price.priceExpression === '' ||
    !price.priceCalculationType
  ) {
    callback(false)
  } else {
    callback(true)
  }
}
